// Współdzielona definicja pozycji menu nawigacyjnego - używana zarówno przez
// Layout.js (renderowanie nawigacji) jak i Settings.js (konfiguracja widoczności per rola).
// UWAGA: "Czas pracy" celowo NIE jest tutaj - sterowane osobną flagą trybu terminala
// PIN (isTerminal), niezależną od roli, żeby nie mieszać dwóch różnych mechanizmów.
export const MENU_ITEMS = [
  { key: 'tables',      label: 'Stoliki',        icon: '⊞',  path: '/',                  end: true },
  { key: 'reservations',label: 'Rezerwacje',     icon: '📅', path: '/reservations' },
  { key: 'kds',         label: 'KDS',            icon: '🍳', path: '/kitchen/zbiorczy',  external: true },
  { key: 'stats',       label: 'Statystyki',     icon: '📊', path: '/stats' },
  { key: 'history',     label: 'Historia',       icon: '📜', path: '/history' },
  { key: 'invoices',    label: 'Faktury',        icon: '🧾', path: '/invoices' },
  { key: 'payables',    label: 'Terminarz',      icon: '📆', path: '/payables' },
  { key: 'cash',        label: 'Kasa',           icon: '💰', path: '/cash' },
  { key: 'contractors', label: 'Kontrahenci',    icon: '🏢', path: '/contractors' },
  { key: 'menu',        label: 'Menu',           icon: '📋', path: '/menu' },
  { key: 'cash_today',  label: 'Kasa — dzień',   icon: '📒', path: '/cash-today' },
  { key: 'users',       label: 'Użytkownicy',    icon: '👥', path: '/users' },
  { key: 'payroll',     label: 'Wynagrodzenia',  icon: '💵', path: '/payroll' },
  { key: 'settings',    label: 'Ustawienia',     icon: '⚙️', path: '/settings' },
];

export const ALL_MENU_KEYS = MENU_ITEMS.map(m => m.key);
